import { Component, OnInit, Input } from '@angular/core';
import { DemandReductionStation } from 'src/app/services/demand-reduction-data.service';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-demand-constraints-button',
  templateUrl: './demand-constraints-button.component.html',
  styleUrls: ['./demand-constraints-button.component.scss'],
  providers: [NgbModalConfig, NgbModal]
})
export class DemandConstraintsButtonComponent implements OnInit {

  @Input() station: DemandReductionStation;

  constructor(private modalConfig: NgbModalConfig, private modalService: NgbModal) {
    modalConfig.backdrop = 'static';
  }

  ngOnInit() {
  }

  open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-constraints'});
  }

}
